module.exports = __webpack_public_path__ + "img/logo-purple.73a8ca73.png";